module.exports = __webpack_public_path__ + "img/meh-rolling-eyes.231677f1.svg";